import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import './projRollingImage.css';

const ProjRollingImage = ({data, content, aspectRatio}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [firstRollingTitle, setFirstRollingTitle] = useState(null);
    const [secondRollingTitle, setSecondRollingTitle] = useState(null);

    useEffect(() => {
        let length = content.rollingTitle.length;

        setFirstRollingTitle(content.rollingTitle[0])
        setSecondRollingTitle(content.rollingTitle[length - 1])
    }, [])

    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }

    return(
        <>
        { firstRollingTitle &&
            <div className="rolling_image__wrapper">
                {/* <div className="background_lyric__wrapper">
                    <div className="first_ticker ticker_wrapper">
                        <span className="lyric_ticker">This is a test This is a test. This is a test This is a test. This is a test This is a test. This is a test This is a test</span>
                        <span className="lyric_ticker hollow-text">test This is a test. This is a test This is a test. This is a test This is a test. This is a test This is a test</span>
                    </div>
                    <div className="second_ticker ticker_wrapper">
                        <span className="lyric_ticker">This is a test This is a test. This is a test This is a test. This is a test This is a test. This is a test This is a test</span>
                        <span className="lyric_ticker hollow-text">test This is a test. This is a test This is a test. This is a test This is a test. This is a test This is a test</span>
                    </div>
                </div> */}
                <div className="ticker-wrap first_ticker">
                    <div className="ticker">
                        <span className="item-collection-1">
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        </span>
                        <span className="item-collection-2">
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        <span className="item">{firstRollingTitle}</span>
                        </span>
                    </div>
                </div>
                <div className="ticker-wrap second_ticker">
                    <div className="ticker">
                        <span className="item-collection-1">
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        </span>
                        <span className="item-collection-2">
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        <span className="item">{secondRollingTitle}</span>
                        </span>
                    </div>
                </div>
                    
                    
                <div className="foreground_image__wrapper" 
                    style={{
                        position: "relative",
                        aspectRatio: aspectRatio    
                    }}>
                    <img src={data.placeholder}  style={{filter: "blur(5px)"}}/>
                    <motion.img 
                        initial="initial"
                        animate={isLoaded ? "animate" : "initial"}
                        exit="exit"
                        variants={imgVariants}
                        src={data.backgroundImage} 
                        onLoad={(e) => {
                            setIsLoaded(true);
                        } }
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                        }}
                    />
                </div>
            </div>
        }
        
        </>
    )
}

export default ProjRollingImage;